import React from "react";
import styled from "styled-components";
import WxSelect from "../select";

export interface WxSwatchCheckboxProps {
  onSelect: () => void;
  list: string[];
}

const WxSwatchCheckbox = ({ onSelect, list }: WxSwatchCheckboxProps) => (
  <Container>
    {list.map((label, index) => (
      <React.Fragment key={`checkbox-${label}-${index}`}>
        <WxSelect onSelect={onSelect} label={label} />
      </React.Fragment>
    ))}
  </Container>
);

const Container = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export default WxSwatchCheckbox;
